module.exports = __webpack_public_path__ + "img/12.b95aea81.jpg";